import { selectInventoryAsyncResponse } from "./types";
import * as inventoryActions from "./inventories.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_INVENTORY, retrieveToken } from "../../../helpers/api";

export function* selectInventory(action: ReturnType<typeof inventoryActions.selectInventoryAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_INVENTORY.SELECT_INVENTORY(action.payload.id), token);
    if (result.status === 200) {
      const parsed: selectInventoryAsyncResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.selectInventoryAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.selectInventoryAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(inventoryActions.selectInventoryAsync.failure(parsed));
  }
}

export default function* inventoriesSagaSelectInventory() {
  yield takeEvery(inventoryActions.selectInventoryAsync.request, selectInventory);
}
